import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { Field } from 'redux-form';
import { withRouter } from 'react-router-dom';
import Loading from '@justgiving/loading';
import Alert from '@justgiving/alert';
import { renderField } from 'utils/FormUtils';
import { createErrorKey } from 'utils';
import FormError from 'components/Alert/FormError';
import { Trans } from 'react-i18next';

class AddPhoneFormComponent extends Component {
  static propTypes = {
    fetchData: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    trackPageView: PropTypes.func.isRequired,
    trackLinkClick: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    resetAppErrors: PropTypes.func.isRequired,
    submitHandler: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    submitSucceeded: PropTypes.bool,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    verifyPhone: PropTypes.shape({
      verified: PropTypes.bool,
    }).isRequired,
    status: PropTypes.shape({
      isFetching: PropTypes.bool.isRequired,
      fetchError: PropTypes.bool.isRequired,
      postError: PropTypes.bool.isRequired,
      errorMessage: PropTypes.string,
    }).isRequired,
    history: PropTypes.shape({
      push: PropTypes.func,
    }),
  };

  static defaultProps = {
    submitting: false,
    submitSucceeded: false,
    error: false,
  };

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    const { fetchData, trackPageView } = this.props;
    fetchData();
    trackPageView('phone', 'personal details > phone');
  }

  componentWillUnmount() {
    this.props.reset();
    this.props.resetAppErrors();
  }

  onSubmit(values) {
    const { trackLinkClick, submitHandler, history } = this.props;
    trackLinkClick('button', 'personal details > phone', 'verify number');
    return submitHandler(values, history.push);
  }

  render() {
    const {
      handleSubmit,
      submitSucceeded,
      submitting,
      verifyPhone,
      status,
      error, // redux-form error
    } = this.props;

    if (status.isFetching) {
      return <Loading size="large" colour="purple" />;
    }

    const errorKey = createErrorKey(status.errorMessage);

    return (
      <form
        method="POST"
        className="jg-space-mtmd"
        onSubmit={handleSubmit(this.onSubmit)}
      >
        {(status.errorMessage || error) && <FormError apiError={errorKey} />}
        {submitSucceeded && !status.errorMessage && (
          <Alert type="success" className="qa-message__success jg-space-mbmd">
            <Trans i18nKey="personalDetails.mobileNumberUpdated">
              Your mobile number has been updated.
            </Trans>
          </Alert>
        )}
        {verifyPhone.verified && (
          <Alert type="success" className="qa-message__success jg-space-mbmd">
            <Trans i18nKey="personalDetails.mobileNumberVerified">
              Your mobile number has been verified.
            </Trans>
          </Alert>
        )}
        <div className="jg-form-group">
          <label htmlFor="PhoneNumber" className="jg-form-label form-row">
            <Trans i18nKey="personalDetails.mobileNumberUK">
              Mobile Number (United Kingdom)
            </Trans>
            <Field
              disabled={Boolean(status.fetchError)}
              name="PhoneNumber"
              component={renderField}
              type="text"
              label="Phone Number"
              autoComplete="tel"
            />
          </label>
          {submitting ? (
            <button type="submit" className="jg-btn jg-btn--brand" disabled>
              <Loading size="small" colour="white" />
            </button>
          ) : (
            <button
              disabled={status.fetchError}
              type="submit"
              className="jg-btn jg-btn--brand qa-button__submit"
            >
              <Trans i18nKey="personalDetails.verifyMobileNumber">
                Verify Mobile Number
              </Trans>
            </button>
          )}
        </div>
      </form>
    );
  }
}

export default withRouter(AddPhoneFormComponent);
